@for (option of materialIndicatorOptions; track option.id) {
    <button mat-menu-item class="d-flex align-items-center justify-content-between"
        (click)="selectOption(option.id, $event)">
        <mat-icon class="d-flex align-items-center justify-content-start">{{enabledIndicatorMap[option.id] ? 'done' : ''}}</mat-icon>
        <span class="text-center">{{option.label | translate}}</span>
    </button>
}

